(function () {
  window.smk = window.smk || {};
  const smk = window.smk || {};

  smk.product = window.smk.product || {};
  window.smk.product = window.smk.product || {};

  const PRODUCT_CONFIG = {
    BASE_URL: '/products',
    PRODUCT_TEMPLATES: {
      FAMILY_COLORS_HTML: 'family-colors'
    }
  };

  const getFamilyColorsHtml = (productHandle) => {
    return $.get(`${PRODUCT_CONFIG.BASE_URL}/${productHandle}`, {
      view: PRODUCT_CONFIG.PRODUCT_TEMPLATES.FAMILY_COLORS_HTML,
    })
  }


  window.smk.product = {
    ...window.smk.product,
    ...{
      PRODUCT_CONFIG,
      getFamilyColorsHtml
    }
  }

  smk.product = window.smk.product;

})();

